import { TUILogin } from '@tencentcloud/tui-core'
import { framework } from '../TUIKit/adapter-vue'

export function TimLogin(val) {
  TUILogin.login({
    SDKAppID: val.im_app_id,
    userID: val.im_user_id,
    userSig: val.im_user_sig,
    useUploadPlugin: true,
    framework,
  })
    .then(() => {})
    .catch(() => {})
}
